<template>
  <div class="main" style="height: 100%; width:100%">
    <a-row style="height: 100%;width: 100%;">
      <a-col
        :xs="0"
        :sm="0"
        :md="0"
        :lg="8"
        :xl="8"
        style="height: 100%;position: relative"
        class="solebackground"
      >
        <tk-flex column center style="position: relative; margin-top: 150px; ">
          <div :style="langType === 'cn' ? 'width: 60%;' :`width: 80%;`">
            <div
              style="color: #ffffff; font-size: 36px;font-weight: bold; ;text-align:left"
            >{{from === 'Revenge' ? lang.common.nameRevenge : lang.common.name }}</div>
            <div
              style="color: #ffffff; font-size: 24px; text-align:left; "
              class="m-t-32"
            >{{lang.common.welcome}}</div>
          </div>
        </tk-flex>
        <tk-image :src="from === 'Revenge' ? revengeLogo: solestageLogo" style="position:relative;left:50%;top:10%;transform: translateX(-50%);" />
      </a-col>
      <a-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16" style="height: 100%;position: relative;">
        <!-- 页面成功内容 -->
        <tk-flex
          v-if="showModal"
          class="text-center"
          column
          center
          style="height:100%;padding-top: 18vw"
        >
          <tk-icon style="height:50px;width:50px;color:black;">success</tk-icon>
          <div class="font-24 m-t-10 m-b-20">{{lang.forget.success}}</div>
          <div class="font-14" style="word-break:break-all">{{lang.forget.finishSlogan}}</div>
          <a-button
            v-if="type === '0'"
            size="large"
            type="primary"
            style="max-width: 385px;width:100%;margin-top: 50px;background-color:#F6313F!important"
            :loading="loading"
            class="highLightButton"
            @click="login"
          >{{lang.forget.logAdmin}}</a-button>
        </tk-flex>
        <!-- 页面无效内容 -->
        <!-- <tk-flex
          v-if="isInvalid"
          class="text-center"
          column
          center
          style="height: 100%;padding-top: 18vw"
        >
          <tk-icon style="height:50px;width:50px;color:black;">fail</tk-icon>
          <div class="font-24 m-t-10 m-b-20">{{lang.forget.pastDue}}</div>
          <div class="font-14" style="word-break:break-all">{{lang.forget.pastDueSlogan}}</div>
        </tk-flex>-->
        <!-- 重置密码表单 -->
        <tk-flex
          v-if="!showModal"
          center
          middle
          column
          style="width:100%;height: 100%;"
          class="geryBackground"
        >
          <a-form class="m-b-30 p-b-30" :class="{mywidth: !tkUa.isMobile, mywidth1: tkUa.isMobile}">
            <div v-if="tkUa.isMobile" :class="{'revenge': from === 'Revenge'}" style="width:100%" class="m-b-24">
              <tk-image
                v-if="tkUa.isMobile"
                :src="from === 'Revenge' ? mobileRevenge : mobileSoleLogo"
              />
            </div>
            <a-form-item>
              <div :class="{'revenge': from === 'Revenge'}" style="font-size: 28px; font-weight:700;">{{lang.forget.title}}</div>
            </a-form-item>
            <a-form-item
              :help="validateStatus.password !== 'error' ? '' : help"
              :validate-status="validateStatus.password !== 'error' ? '' : 'error'"
            >
              <a-input-password
                @change="inputValidate(0)"
                v-model="password"
                :placeholder="lang.forget.title"
              />
            </a-form-item>
            <a-form-item
              :help="validateStatus.confirmPassword !== 'error' ? '' : help"
              :validate-status="validateStatus.confirmPassword !== 'error' ? '' : 'error'"
            >
              <a-input-password
                @change="inputValidate(1)"
                v-model="confirmPassword"
                :placeholder="lang.forget.confirmNew"
              />
            </a-form-item>
            <a-button
              size="large"
              type="primary"
              style="width:100%"
              :loading="loading"
              class="highLightButton"
              @click="reset"
            >{{lang.forget.confirm}}</a-button>
          </a-form>
        </tk-flex>
      </a-col>
    </a-row>
    <!-- <a-modal
      :visible="showModal"
      :footer="null"
      @cancel="() => showModal = false"
      centered
      :width="tkUa.isMobile? '80%': '50%'"
    >
      <tk-flex column center middle style="height:30%; padding-top:30px; padding-bottom:40px;">
        <tk-icon class="m-t-32" style="height:50px;width:50px;color:black">success</tk-icon>
        <div style="font-size:24px;color: #000000">{{lang.forget.success}}</div>
        <div style="height:50px"></div>
        <div style="width:60%; font-size:14px;word-break:break-all">{{lang.forget.finishSlogan}}</div>
      </tk-flex>
    </a-modal>-->
  </div>
</template>
<script>
import NP from 'number-precision'
import './login.scss'
import solestageLogo from '../../../assets/image/solelogo.png'
import revengeLogo from '../../../assets/image/revengeLogo.png'

import mobileSoleLogo from '../../../assets/image/solelogomobile1.5.png'
import mobileRevenge from '../../../assets/image/revenge-mb.png'

import { tkUa } from '@moke/vue-tk'
export default {
  props: {
    email: String,
    lang: Object,
    langType: String,
    type: String,
    userid: String,
    sentAt: Number,
    emailId: String,
    url: String,
    from: String
  },
  data () {
    return {
      tkUa,
      help: '',
      mobileSoleLogo,
      mobileRevenge,
      validateStatus: {
        password: '',
        confirmPassword: ''
      },
      password: '',
      confirmPassword: '',
      solestageLogo,
      revengeLogo,
      loading: false,
      showModal: false
    }
  },
  computed: {
    myEmail () {
      return this.email
    },
    id () {
      return this.userid
    }
  },
  mounted () {
    console.log('tttype', this.type)
    // console.log(this.tkUa.isMobile)
  },
  methods: {
    init () {
      this.help = ''
      this.validateStatus = {
        password: '',
        confirmPassword: ''
      }
      this.password = ''
      this.confirmPassword = ''
      this.loading = false
      this.showModal = false
    },
    passwordFormate (val) {
      let pwdRegex = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/
      return pwdRegex.test(val)
    },
    login () {
      let adminUrl = this.url === 'https://cloud.solestage.mokekeji.com'
        ? 'https://admin.solestage.mokekeji.com/user/login'
        : 'https://admin.solestage-dev.mokekeji.com/user/login'
      window.open(adminUrl, '_self')
    },
    async reset () {
      let now = new Date().getTime()
      let duration = NP.round(NP.divide((now - this.sentAt), 60000), 2)
      if (duration > 10) { // 判断是否过期
        return this.$notification['warning']({
          message: this.lang.common.warning,
          description: this.lang.common.invalid
        })
      }
      this.validateStatus.password = ''
      this.validateStatus.confirmPassword = ''
      let pass = this.validate()
      if (!pass) return
      try {
        this.loading = true
        console.log(this.email, this.password, this.id, this.emailId)
        let { data: res } = await this.$tkParse.post(`${this.url}/email/handleEmail`, {
        // let { data: res } = await this.$tkParse.post('http://192.168.2.235:3333/email/handleEmail', {
          info: {
            email: this.email,
            password: this.password,
            id: this.id
          },
          emailId: this.emailId,
          type: 'resetPassword'
        })
        console.log('rrres', res)
        let status
        let msg
        let description
        switch (res) {
          case 'success':
            this.init()
            this.showModal = true
            status = 'success'
            msg = this.lang.forget.success
            description = this.lang.forget.isSubmitted
            this.showModal = true
            this.password = ''
            this.confirmPassword = ''
            break
          case 'invalid':
            status = 'error'
            msg = this.lang.forget.invalid
            description = this.lang.forget.invalidDes
            break
          case 'error':
            status = 'error'
            msg = this.lang.common.networkError
            description = this.lang.common.retry
            break
          default:
            break
        }
        this.loading = false
        this.$notification[status]({
          message: msg,
          description: description
        })
      } catch (e) {
        console.log('e', e)
        this.loading = false
        this.$notification['error']({
          message: this.lang.common.networkError,
          description: this.lang.common.retry
        })
      }
    },

    inputValidate (type) {
      // let correctFormate = this.passwordFormate()
      // console.log('验证格式', correctFormate)
      // if (!correctFormate) {
      //   switch (type) {
      //     case 0:
      //       this.validateStatus.password = 'error'
      //       break
      //     case 1:
      //       this.validateStatus.confirmPassword = 'error'
      //       break
      //   }
      // } else {
      //   switch (type) {
      //     case 0:
      //       this.validateStatus.password = ''
      //       break
      //     case 1:
      //       this.validateStatus.confirmPassword = ''
      //       break
      //   }
      // }
      let correctFormate
      switch (type) {
        case 0:
          correctFormate = this.passwordFormate(this.password)
          this.validateStatus.password = correctFormate ? '' : 'error'
          break
        case 1:
          correctFormate = this.passwordFormate(this.confirmPassword)
          this.validateStatus.confirmPassword = correctFormate ? '' : 'error'
          break
      }
      console.log('correctFormate', correctFormate)
      this.help = this.lang.forget.formate
    },

    validate () {
      let pass = true
      if (this.password === '' || this.confirmPassword === '') {
        this.validateStatus.password = 'error'
        this.help = this.lang.common.notEmpty
        pass = false
      }
      // if (this.confirmPassword === '') {
      //   this.validateStatus.confirmPassword = 'error'
      //   this.help = this.lang.common.notEmpty
      //   pass = false
      // }
      if (this.password !== this.confirmPassword) {
        this.validateStatus.password = this.validateStatus.confirmPassword = 'error'
        this.help = this.lang.forget.warning
        pass = false
      }
      let correctFormate = this.passwordFormate(this.password)
      if (!correctFormate) {
        this.validateStatus.password = this.validateStatus.confirmPassword = 'error'
        this.help = this.lang.forget.formate
        pass = false
      }
      return pass
    }
  }
}
</script>

<style lang="scss" scoped>

 .whiteText {
    color: white;
  }

 .mywidth {
    width: 35%;
  }

  .mywidth1 {
    width: 65%;
  }

 .label {
   font-size: 16px;
   font-weight: 600;
 }

 button.highLightButton{
  background-color: #F6313F;
    border-color: #F6313F;
 }

 button.highLightButton:hover {
    background-color: #F6313F;
    border-color: #F6313F;
  }

  .solebackground {
    background-image: url("../../../assets/image/solebackground.png");
    background-size: 100% 100%;
  }

  // 媒体查询992px以下
  @media screen and (max-width: 992px) {
    .mywidth {
      width: 80%;
    }

    .mywidth1 {
      width: 80%;
    }
    .revenge{
      text-align: center;
    }
  }
</style>
